import React, { Component } from "react";
import "./App.css";
import Simplify360Chat from "./Simplify360Chat/Simplify360Chat";
import HWLogsDisplay from "./Simplify360Chat/HWLibrary/HWLogsDisplay";
import { s360ConfigService } from "./Simplify360Chat/Services/S360Config";
import secureLocalStorage from "react-secure-storage";
import {
  watchForChatSDKEvents,
  fetchConfigDetailsFromClientHost,
} from "./Simplify360Chat/Services/HWIframeBridge";
import Simplify360Tatasky from "./Simplify360Tatasky/Simplify360Tatasky";
import Login from "./Simplify360Tatasky/Login";
import ClosePopUp from "./Simplify360Tatasky/ClosePopUp";
import apiService from "./Simplify360Tatasky/APIService";
import SecureStorage from "./utils/SecureStorage";

class App extends Component {
  constructor(props) {
    super(props);
    // secureLocalStorage.setItem("hello",123)
    SecureStorage.setItem("hello", 123);
    s360ConfigService.loadClientConfigFromToken();

    let configEncodedString = (window.location.pathname || "").substring(
      1,
      (window.location.pathname || "").length
    );

    const decodedString =
      s360ConfigService.decodeConfigToken(configEncodedString);

    this.state = {
      subscriberId:
        decodedString != null
          ? decodedString.subscriberId
          : s360ConfigService.getConfig.subscriberId,
      authenticated:
        decodedString != null
          ? decodedString.authenticated
          : s360ConfigService.getConfig.authenticated,
      viewType: s360ConfigService.getConfig.viewType,
      sessionId: s360ConfigService.config.sessionId,
      source: s360ConfigService.config.source,
      inputbox: s360ConfigService.config.inputbox,
      action: decodedString != null ? decodedString.action : null,
      src: decodedString != null ? decodedString.src : null,
      // hideLoading: decodedString != null ? decodedString.hideLoading : null,
      hideLoading: false,
      // decodedString != null ? decodedString.hideLoading : null,
      launchOnButton: decodedString != null ? decodedString.hideLoading : null,
      loginCount: 0,
      openChat: decodedString != null ? decodedString.openChat : null,
      coachingData: null,
    };


    //   watchForChatSDKEvents(
    //     this,
    //     () => {},
    //     () => {
    //       console.log(s360ConfigService, "CONFIG");
    //       // On Config Update Callback
    //       this.setState({
    //         subscriberId: s360ConfigService.config.subscriberId,
    //         authenticated: s360ConfigService.config.authenticated,
    //         viewType: s360ConfigService.config.viewType,
    //         sessionId: s360ConfigService.config.sessionId,
    //         source: s360ConfigService.config.source,
    //       });
    //     }
    //   );
  }

  fetchCoachingData = async () => {
      try {
        const response = await apiService.getCoachingCount(this.state.subscriberId
        );
        if (response?.data?.code === 200) {
                  this.setState({
                    coachingData: response?.data?.coachingShow,
                  });
                  console.log("API Response:", response)
        }
       } catch (error) {
        console.error("Error fetching coaching data:", error);
      }
    };

  componentDidMount() {
    if (this.state.authenticated) {
      this.fetchCoachingData();
    } else {
     this.setState({
      coachingData : true
     })
    }
    // console.log(this.state.loginCount)
    fetchConfigDetailsFromClientHost();
    window.addEventListener('resize', reportWindowSize());
  }
  render() {
    // console.log(secureLocalStorage.getItem("hello"))
    let configEncodedString = (window.location.pathname || "").substring(
      1,
      (window.location.pathname || "").length
    );
    const decodedString =
      s360ConfigService.decodeConfigToken(configEncodedString);
    // console.log(decodedString,configEncodedString,"batman",localStorage.getItem("loginDetails"));
    return (
      <div className="App">
        {/* <HWLogsDisplay/>  */}
        {/* {s360ConfigService.isConfigured() && < Simplify360Chat {...this.state}/>}  */}
        {/* < Simplify360Chat {...this.state}/>   */}

        <Simplify360Tatasky
          coachingData={this.state.coachingData}
          subscriberId={this.state.subscriberId}
          inputbox={this.state.inputbox}
          authenticated={this.state.authenticated}
          viewType={this.state.viewType}
          sessionId={this.state.sessionId}
          source={this.state.source}
          action={this.state.action}
          hideLoading={this.state.hideLoading}
          launchOnButton={this.state.launchOnButton}
          loginCount={this.state.loginCount}
          openChat={this.state.openChat}
          src={this.state.src}
        />
        {/* <Login /> */}
        {/* <ClosePopUp /> */}
      </div>
    );
  }
}

const reportWindowSize = () => {
  let chatFrame = document.getElementById("top");

  const zoomlevel = Math.round(window.devicePixelRatio * 100);

  console.log("zoomlevel", zoomlevel)

  if (chatFrame) {
    // console.log(x, "abcde");
    if (window.innerWidth <= 900) {
      // If media query matches

      chatFrame.style =
        "position: fixed; width:100vw !important; height:100% !important;max-height:100%;right:0px;bottom: 0px;overflow: hidden;z-index:20;";
    } else {
      chatFrame.style =
        "position: fixed; width:400px; height:530px;max-height:100%;right:20px;bottom: 20px;overflow: hidden;z-index:20; box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;";
    }
    if (window.innerHeight < 650 && window.innerWidth > 450) {
      if (zoomlevel > 250) {
        chatFrame.style =
          "position: fixed; width:200px; height:200px;max-height:90%;right:-3%;bottom: -5%;overflow: hidden;z-index:20; scale:0.83;";
      } else {
        chatFrame.style =
          "position: fixed; width:393px; height:550px;max-height:90%;right:-3%;bottom: -5%;overflow: hidden;z-index:20; scale:0.83;";
      }
    }
    if (window.innerHeight < 650 && window.innerWidth < 450) {
      chatFrame.style =
        "position: fixed; width:100%; height:100%;max-height:100%;right:0;bottom:0;overflow: hidden;z-index:20;";
    }
    // onChatOpen();
  }
};

// generateHistoryURL = function (subscriberId) {
//   let configTokenData = { subscriberId: subscriberId, viewType: "history" }
//   let configTokenJSON = encodeURIComponent(btoa(JSON.stringify(configTokenData)));
//   let params = { configToken: configTokenJSON }
//   let urlPath = "http://simplify-360-chat-sdk-tatasky.s3-website.ap-south-1.amazonaws.com/" + JSON.stringify(Object.keys(params).map(function (k) { return params[k]; }).join('/'));
//   urlPath = urlPath.replace(/"/g, '');
//   return urlPath;
// };

// generateHistoryURL = function (subscriberId) {
//   let configTokenData = { subscriberId: subscriberId, viewType: "history" }
//   let configTokenJSON = encodeURIComponent(btoa(JSON.stringify(configTokenData)));
//   let params = { configToken: configTokenJSON }
//   let urlPath = "http:localhost:3000/" + JSON.stringify(Object.keys(params).map(function (k) { return params[k]; }).join('/'));
//   urlPath = urlPath.replace(/"/g, '');
//   return urlPath;
// };

export default App;
